import React from 'react';
import { connect } from 'react-redux';

import { toggleSpinner } from 'apps/auth/actions/appAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { AUTH_SEND_MAIN_LINK } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { logWarn } from 'apps/auth/helpers/clientLogger';

const CancelPopup = (props) => {
    const cancelAction = (e) => {
        e.preventDefault();
        props.toggleSpinner(true);
        props.popupRef.current?.close();
        apiFetchData(`/auth/card/confirm/cancel/${props.sms_confirm.objectId}`)
            .then((json) => {
                if (json && json.redirectTo) {
                    window.location.href = json.redirectTo;
                } else {
                    props.toggleSpinner(false);
                }
            })
            .catch((error) => {
                logWarn(error);
                props.toggleSpinner(false);
            });
    };

    return (
        <SimplePopup withoutBorder popupRef={props.popupRef}>
            <PopupButton
                href={AUTH_SEND_MAIN_LINK}
                iconName="clock"
                text={props.verifyCardLater}
                onClick={() => {
                    props.toggleSpinner(true);
                    props.popupRef.current?.close();
                }}
            />
            <PopupButton
                href={`/auth/card/confirm/cancel/${props.sms_confirm.objectId}`}
                iconName="cross"
                text={props.verifyCancel}
                onClick={(e) => cancelAction(e)}
            />
        </SimplePopup>
    );
};
const mapStateToProps = (state) => {
    return {
        verifyCardLater: state.messages.pageMessages.verifyCardLater,
        verifyCancel: state.messages.pageMessages.verifyCancel,
        sms_confirm: state.extra.sms_confirm,
    };
};
export default connect(mapStateToProps, { toggleSpinner })(CancelPopup);
